export const KiB = 2 ** 10

export const MiB = 2 ** 20
